import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { astaV2Search, urvalsgrupper, larosaten } from '../Asta/astaService.ts';
import type { AstaSettings, AstaTexter, AstaDisplaySettings, AstaFilterSettings, SearchResult, AstaResultatStatusType } from '../../types/AstaTypes';

const setEquals = (xs: Set<any>, ys: Set<any>): boolean => xs.size === ys.size && [...xs].every((x) => ys.has(x));

const useInternalStore = defineStore('asta-internal', {
  state: (): AstaResultatStatusType => ({
    searchfor: '',
    searchterm: '',
    searchkategori: '',
    tillfalle: 'urv2',
    utbildningstyp: null,
    vygroup: 'antagna',
    vy: 'antagningspoang-urv2',
    page: 1, // startar på 1 - OBS!! verkar användas en till separat variabel för det här..
    pagesize: 10,
    larosaten: [],
    allaLarosaten: null, //TODO: computed/getter
    urvalsgrupper: [],
    allaUrvalsgrupper: [], //TODO: computed/getter
    tmpUrvalsgrupper: [], //TODO: ta bort?!
    visaAllaUrvalsgrupper: false,
    sorteringskolumn: undefined,
    sorteringsurvalsgrupp: null,
    sorteringsordningdesc: false,
    data: null,
    showMobileSorting: false,
    hasUrval1ResultData: false,
    hasUrval2ResultData: false,
    setFocusOn: '',
  }),
});

export default defineStore('asta', () => {
  const internalState = useInternalStore();
  const settings = ref<AstaSettings>({} as AstaSettings);

  //TODO: skapa ref för tex filter, display, result mm för att ersätta internalState
  //      Att det inte gjorts initialt är pga internalState är en exakt kopia av det nuvarande objekt som används
  //      så all befintlig kog bör gå exekvera mot det objektet, så konvertering bör bli enklare med det.

  const init = (settingsData: AstaSettings, data: AstaResultatStatusType) => {
    console.log('AS:init', data);
    internalState.$state = data;
    settings.value = settingsData;
  };

  const search = () => {
    console.log('AS:search');
    astaV2Search(internalState, internalState.pagesize)
      .then((response) => {
        console.log('AS:search-result', response);
        internalState.data = response!;
      })
      .catch((error: any) => {
        console.error('Error while fetching data', error);
      });
  };

  const debug = () => {
    console.log('AS:debug');
    larosaten(internalState).then((r) => {
      internalState.allaLarosaten = r.data; //TODO: undersök..
      console.log('AS:debug-larosaten', r);
    });

    const p = { ...internalState };
    p.tillfalle = p.tillfalle == 'urv1' ? 'urv2' : 'urv1';
    urvalsgrupper(p).then((r) => {
      console.log('AS:debug-urvalsgrupper', r);
      internalState.allaUrvalsgrupper = r.data; //TODO: undersök..
    });
  };

  const setDisplay = (data: AstaDisplaySettings) => {
    console.log('AS:setDisplay', data);
    internalState.$patch({
      vygroup: data.vygroup,
      vy: data.vy,
      urvalsgrupper: data.urvalsgrupper,
    });
  };

  const setFilter = (data: AstaFilterSettings) => {
    const isUbildningsTypChanged = internalState.utbildningstyp != data.utbildningstyp;
    const isLarosatenChanged = !setEquals(new Set(internalState.larosaten), new Set(data.larosaten));
    console.log('AS:setFilter', data, isUbildningsTypChanged, isLarosatenChanged);
    if (isUbildningsTypChanged || isLarosatenChanged) {
      internalState.$patch({
        utbildningstyp: data.utbildningstyp,
        larosaten: data.larosaten,
      });
      search();
    }
  };

  const display = computed((): AstaDisplaySettings => {
    return {
      vygroup: internalState.vygroup,
      vy: internalState.vy,
      urvalsgrupper: internalState.urvalsgrupper,
    };
  });

  const filter = computed((): AstaFilterSettings => {
    return {
      utbildningstyp: internalState.utbildningstyp,
      larosaten: internalState.larosaten,
    };
  });

  const result = computed((): SearchResult | null => {
    console.log('AS:result:get', internalState.data);
    return internalState.data;
  });

  const texter = computed((): AstaTexter => settings.value.Texter);

  const allaUrvalsgrupper = computed(() => internalState.allaUrvalsgrupper);

  const allaUrvalsgrupperTest = computed((): any[] => {
    console.log('AS:allaUrvalsgrupperTest:get');
    //test med computed.. ej korrekt skulle jag tro. kolla gamla koden och bygg motsvarande.
    if (internalState.data?.data?.length === 0 && internalState.allaUrvalsgrupper.length === 0) {
      return [];
    }

    const data1 =
      internalState.data?.data
        ?.filter((i) => i.urval1 != null)
        .map((i) => i.urval1)
        .flatMap((u) => u!.urvalsgrupper)
        .map((u) => u.urvalsgruppId) ?? [];
    const data2 = internalState.allaUrvalsgrupper?.map((i) => i.urvalsgruppId);

    const distinct = new Set([...data1, ...data2]);
    return [...distinct].map((id) => ({ urvalsgruppId: id }));
  });

  return { init, settings, texter, search, debug, setDisplay, setFilter, display, filter, result, allaUrvalsgrupper, allaUrvalsgrupperTest };
});
